import { footerHeight } from 'common/components/Footer';
import styled from 'styled-components';

export const PublicContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: calc(100vh - ${footerHeight});
`;
